import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const SproutSvg = () => (
  <svg
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    aria-hidden="true"
  >
    {/* Stem */}
    <path d="M12 21V11" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
    {/* Left leaf */}
    <path d="M12 13c-3 0-5-1.8-5-5 3 0 5 1.8 5 5z" />
    {/* Right leaf */}
    <path d="M12 11c3 0 5-1.8 5-5-3 0-5 1.8-5 5z" />
    {/* Soil line */}
    <path d="M5 21h14" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" fill="none" />
  </svg>
);

/** Seedling / sprout icon — used for the patterns (rootstocks) admin
 *  page. Renders inside antd's Icon wrapper so it inherits color/size
 *  from the surrounding text just like the rest of @ant-design/icons. */
export const SproutIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SproutSvg} {...props} />
);

export default SproutIcon;
